import React, { useEffect, useState } from 'react';
import {
  getPlatformStatus,
  subscribePlatformStatus,
  retryPlatformNow,
  type PlatformStatus,
} from '../constants/auth';

interface PlatformStatusBannerProps {
  onRecovered?: () => void;
}

const PlatformStatusBanner: React.FC<PlatformStatusBannerProps> = ({ onRecovered }) => {
  const [status, setStatus] = useState<PlatformStatus>(getPlatformStatus());
  const [retrying, setRetrying] = useState(false);

  useEffect(() => {
    let prev = getPlatformStatus();
    setStatus(prev);
    const unsubscribe = subscribePlatformStatus((next) => {
      setStatus(next);
      if (prev === 'offline' && next === 'online') {
        onRecovered?.();
      }
      prev = next;
    });
    return unsubscribe;
  }, [onRecovered]);

  if (status !== 'offline') return null;

  const handleRetry = async () => {
    if (retrying) return;
    setRetrying(true);
    try {
      await retryPlatformNow();
    } finally {
      setRetrying(false);
    }
  };

  return (
    <div className="w-full bg-amber-100 dark:bg-amber-900/40 border-b border-amber-300 dark:border-amber-700/60 text-amber-900 dark:text-amber-100 px-4 py-2 text-sm flex items-center justify-center gap-3">
      <span className="inline-block w-2 h-2 rounded-full bg-amber-500 animate-pulse" />
      <span>平台服务暂时不可用，已登录状态保留，本地功能可继续使用</span>
      <button
        type="button"
        onClick={handleRetry}
        disabled={retrying}
        className="px-2.5 py-0.5 rounded-md border border-amber-400/60 hover:bg-amber-200/60 dark:hover:bg-amber-800/40 disabled:opacity-50 text-xs font-medium transition-colors"
      >
        {retrying ? '重试中...' : '重试'}
      </button>
    </div>
  );
};

export default PlatformStatusBanner;
